/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type access_AccessMeResponse = {
    /**
     * AuthRole is "admin" or "employee".
     */
    authRole: access_AccessMeResponse.authRole;
    /**
     * DeviceRegistered is true when the request's X-Device-Credential belongs to
     * an active device of the organization. Always false for admin (#1766).
     */
    deviceRegistered: boolean;
    /**
     * DeviceRequired is true when the organization requires a registered device
     * for child data in the employee app and the device rule ran for this caller
     * (an employee holding mobile-employee). Always false for admin (#1766).
     */
    deviceRequired: boolean;
    /**
     * Modules are the granted module keys in catalog order.
     */
    modules: Array<string>;
    /**
     * Role is the professional role value on the covering contract; empty for admin.
     */
    role: string;
    /**
     * WebAccess is true when Modules holds at least one web module.
     */
    webAccess: boolean;
};
export namespace access_AccessMeResponse {
    /**
     * AuthRole is "admin" or "employee".
     */
    export enum authRole {
        ADMIN = 'admin',
        EMPLOYEE = 'employee',
    }
}

